import { IValidator, Validations } from '@samc/centricity-core';
import { IPackageDocumentRequest } from '../Components/PackageDocument';
import { isNullOrEmpty } from '../utils';

export class PackageDocumentValidator implements IValidator<IPackageDocumentRequest> {
  constructor(private validateName: boolean) {
  }
  public isValid(value: IPackageDocumentRequest): Validations<IPackageDocumentRequest> {
    const validations: Validations<IPackageDocumentRequest> = {};

    if (this.validateName) {
      if (isNullOrEmpty(value.documentName)) validations.documentName = 'Document Name must be entered before saving!';
    }
    if (value.packageDocumentTypeId === null) validations.packageDocumentTypeId = 'Document Type is Required!';

    return validations;
  }
}